export default [
  /* Leads */
  {
    path: '/procedures',
    name: 'Procedures',
    meta: {
      descricao: 'Procedures'
    },
    component: () => import('@/pages/procedures/Procedures')
  }
]
